import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import toastr from 'toastr'

export const MERCHANT_PRICING_API = ShipbobAppSettings.MerchantPricingApi.ApiBaseUrl

class DestinationCountriesServiceInternal {
  urls () {
    return {
      getAllCountries: MERCHANT_PRICING_API + 'userlocations/locations',
      getDestinationCountries: MERCHANT_PRICING_API + 'userlocations/destinationcountries',
      getActiveDestinationCountries: MERCHANT_PRICING_API + 'userlocations/activedestinationcountries',
      getActiveDestinationCountriesByFC: MERCHANT_PRICING_API + 'userlocations/activedestinationcountriesbyfc'
    }
  }

  handleGetDestinationCountriesError = (res) => {
    toastr['error']('Unable to retrieve destination countries')
  }

  handleGetNoDestinationCountries = (res) => {
    if(res.data && res.data.length === 0)
      toastr['error']('No destination countries found for the selected source.')
  }

  async getDestinationCountries (originCountry) {
    const request = {
      Url: `${this.urls().getDestinationCountries}/${originCountry}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetDestinationCountriesError, true)
  }

  async getActiveDestinationCountries (originCountry) {
    const request = {
      Url: `${this.urls().getActiveDestinationCountries}/${originCountry}`
    }

    return await HttpWrapper.Get(request, undefined, this.handleGetDestinationCountriesError, true)
  }

  async getActiveDestinationCountriesByFC (fcId) {
    const request = {
      Url: `${this.urls().getActiveDestinationCountriesByFC}/${fcId}`
    }

    return await HttpWrapper.Get(request, this.handleGetNoDestinationCountries, this.handleGetDestinationCountriesError, true)
  }

  async getAllCountries () {
    const request = {
      Url: `${this.urls().getAllCountries}`
    }

    return await HttpWrapper.Get(request, this.handleGetNoDestinationCountries, this.handleGetDestinationCountriesError, true)
  }
}

export const DestinationCountriesService = new DestinationCountriesServiceInternal()
